import { defineComponent as _defineComponent } from 'vue';
import { ref, watch } from "vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SharingIndicator',
    props: {
        accessible: null
    },
    emits: ["makeAccessible"],
    setup(__props, { emit }) {
        const props = __props;
        const makingAccessible = ref(false);
        function makeAccessible() {
            makingAccessible.value = true;
            emit("makeAccessible");
        }
        watch(props, () => {
            makingAccessible.value = false;
        });
        return { __sfc: true, emit, props, makingAccessible, makeAccessible, LoadingSpan };
    }
});
